module.exports = {
      id: "bullet-arrow-usage",
      viewBox: "0 0 22 20",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#bullet-arrow",
      toString: function () {
        return this.url;
      }
    }